import EditAttributeDialog from './editAttributeDialog.container';

export default EditAttributeDialog